var React = require('react');

function ProductsSingleDesign1 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#ProductsSingleDesign1-clip0)","key":0},[React.createElement("path",{"opacity":"0.72","d":"M0.23877 0V331L119.369 179C119.369 179 5.11877 0 0.23877 0Z","fill":"white","key":0}),React.createElement("path",{"d":"M119.359 178.99L173.359 432.99L257.359 128.99L119.359 178.99Z","fill":"white","key":1}),React.createElement("path",{"opacity":"0.48","d":"M0.23877 0H383.359L257.359 128.99L119.359 178.99L0.23877 0Z","fill":"white","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"ProductsSingleDesign1-clip0"},React.createElement("rect",{"width":"383.12","height":"432.99","fill":"white","transform":"translate(0.23877)"})))]);
}

ProductsSingleDesign1.defaultProps = {"width":"384","height":"433","viewBox":"0 0 384 433","fill":"none"};

module.exports = ProductsSingleDesign1;

ProductsSingleDesign1.default = ProductsSingleDesign1;
